import {logErrorToSentry} from "./utils/sentry";

export const logError = (args: any) => {
  logErrorToSentry(args);
};
